import {
  targetGroupsByPhysicalConstants,
  createTargetGroupsByPhysicalConstants,
  editTargetGroupsByPhysicalConstants,
  deleteTargetGroupsByPhysicalConstants,
} from "../_redux-constants";
import { targetGroupsPhysicalService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getTargetGroupsByPhysical(queryParams) {
  function getTargetGroupsByPhysicalLoad() {
    return {
      type: targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_LOADING,
    };
  }
  function getTargetGroupsByPhysicalSuccess(data) {
    return {
      type: targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function getTargetGroupsByPhysicalFailure(error) {
    return {
      type: targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsByPhysicalLoad());
    return targetGroupsPhysicalService
      .getTargetGroupsByPhysical(queryParams)
      .then(
        (data) => {
          dispatch(getTargetGroupsByPhysicalSuccess(data));
        },
        (error) => {
          dispatch(getTargetGroupsByPhysicalFailure(error?.toString()));
        }
      );
  };
}

function createTargetGroupsByPhysical(requestBody, queryParams) {
  function createTargetGroupsByPhysicalLoad() {
    return {
      type: createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_LOADING,
    };
  }
  function createTargetGroupsByPhysicalSuccess(data) {
    return {
      type: createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function createTargetGroupsByPhysicalFailure(error) {
    return {
      type: createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createTargetGroupsByPhysicalLoad());
    return new Promise((resolve, reject) => {
      targetGroupsPhysicalService
        .createTargetGroupsByPhysical(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createTargetGroupsByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createTargetGroupsByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editTargetGroupsByPhysical(requestBody, queryParams) {
  function editTargetGroupsByPhysicalLoad() {
    return {
      type: editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_LOADING,
    };
  }
  function editTargetGroupsByPhysicalSuccess(data) {
    return {
      type: editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function editTargetGroupsByPhysicalFailure(error) {
    return {
      type: editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editTargetGroupsByPhysicalLoad());
    return new Promise((resolve, reject) => {
      targetGroupsPhysicalService
        .editTargetGroupsByPhysical(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editTargetGroupsByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editTargetGroupsByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteTargetGroupsByPhysical(queryParams) {
  function deleteTargetGroupsByPhysicalLoad() {
    return {
      type: deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_LOADING,
    };
  }
  function deleteTargetGroupsByPhysicalSuccess(data) {
    return {
      type: deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function deleteTargetGroupsByPhysicalFailure(error) {
    return {
      type: deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteTargetGroupsByPhysicalLoad());
    return new Promise((resolve, reject) => {
      targetGroupsPhysicalService
        .deleteTargetGroupsByPhysical(queryParams)
        .then(
          (data) => {
            dispatch(deleteTargetGroupsByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteTargetGroupsByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const targetGroupsByPhysicalActions = {
  getTargetGroupsByPhysical,
  createTargetGroupsByPhysical,
  editTargetGroupsByPhysical,
  deleteTargetGroupsByPhysical,
};
